module.exports = __webpack_public_path__ + "static/media/publish.c7cb5c5f.svg";